import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Text from './Text';

const PageHeader = props => {
  return (
    <Header style={props.style}>
      <Text type="pageHeader">{props.children}</Text>
    </Header>
  );
};

PageHeader.defaultProps = {
  children: PropTypes.node,
};

const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1300px;
  min-width: 800px;
  width: 100%;
  margin: auto;
  margin-bottom: 15px;
  position: relative;
`;

export default PageHeader;
